const table = [
  "M1.5 1.14C.67 1.14 0 1.8 0 2.61V13.4c0 .81.67 1.47 1.5 1.47h13c.83 0 1.5-.66 1.5-1.47V2.6c0-.81-.67-1.47-1.5-1.47zM1 3.1h4v2.94H1zm5 0h4v2.94H6zm5 0h4v2.94h-4zM1 7.02h4v2.94H1zm5 0h4v2.94H6zm5 0h4v2.94h-4zM1 10.94h4v2.93H1.5a.5.5 0 0 1-.5-.5zm5 0h4v2.93H6zm5 0h4v2.44a.5.5 0 0 1-.5.49H11z"
];
export {
  table
};
//# sourceMappingURL=table.js.map
